import { useTranslation } from 'next-i18next'

import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import TimesIcon from '~/components/Icons/svgs/TimesIcon'
import WelcomeIcon from '~/components/Icons/svgs/WelcomeIcon'

export default function WelcomeMessage({ onClick }: { onClick: () => void }): React.ReactElement {
  const { t } = useTranslation('chatAi')

  return (
    <>
      <SVGIcon className="fixed -mt-10 ml-10 flex md:hidden z-oracle" icon={WelcomeIcon} onClick={onClick} />
      <div
        className="hidden fixed bottom-42 right-2 md:flex flex-col gap-4 w-full py-3 px-6 max-w-70 border-2 border-purple-light-top rounded-4 whitespace-normal z-oracle bg-black/40 backdrop-blur-md cursor-pointer hover:scale-105 duration-300"
        onClick={onClick}
      >
        <SVGIcon className="absolute right-2 top-2" icon={TimesIcon} pathClassName="text-purple-light-top" size={15} />
        <p className="text-white text-md text-center">{t('welcomeMessage')}</p>
      </div>
    </>
  )
}
